module.exports = __webpack_public_path__ + "static/media/gsr.94272639.svg";